import { FC } from 'react';
import Script from 'next/script';

export interface Props {
  assetId: string;
  popover?: boolean;
}

const WistiaEmbed: FC<Props> = ({ assetId, popover = false }) => {
  return (
    <>
      <Script strategy='lazyOnload' src={`https://fast.wistia.com/embed/medias/${assetId}.jsonp`} />
      <div
        className='wistia_responsive_padding'
        style={{ padding: '56.25% 0 0 0', position: 'relative' }}
      >
        <div
          className='wistia_responsive_wrapper'
          style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}
        >
          <span
            className={`wistia_embed wistia_async_${assetId} popover=${popover.toString()} popoverAnimateThumbnail=false videoFoam=true`}
            style={{
              display: 'inline-block',
              height: '100%',
              position: 'relative',
              width: '100%',
            }}
          >
            &nbsp;
          </span>
        </div>
      </div>
    </>
  );
};

export { WistiaEmbed };
